import * as React from 'react'

/** Highlight a notification's exact landing item after async screen data and tabs have rendered. */
export function useNotificationFocus(target: string | undefined, root?: React.RefObject<HTMLElement | null>) {
  React.useEffect(() => {
    if (!target) return
    let frame = 0
    let stopped = false
    let highlighted: HTMLElement | undefined
    const find = () => {
      if (stopped) return
      const scope = root?.current ?? document
      const nodes = Array.from(scope.querySelectorAll<HTMLElement>('[data-notification-target], [data-notification-targets]'))
      const hit = nodes.find(
        (node) => node.dataset.notificationTarget === target || (node.dataset.notificationTargets ?? '').split(' ').includes(target),
      )
      if (!hit && frame++ < 90) return requestAnimationFrame(find)
      if (!hit) return
      highlighted = hit
      hit.dataset.notificationHighlight = 'true'
      hit.tabIndex = -1
      hit.scrollIntoView({ behavior: 'smooth', block: 'center' })
      hit.focus({ preventScroll: true })
    }
    requestAnimationFrame(find)
    return () => {
      stopped = true
      if (highlighted) delete highlighted.dataset.notificationHighlight
    }
  }, [target, root])
}
